'use strict';

var assign = require('object-assign');

var logger	= require('../../utils/logger.js');

var FluxChangeStore	= require('./flux-change-store.js');
var FluxConstants 	= require('../constants/flux-constants.js');
var FluxDispatcher 	= require('../dispatchers/flux-dispatcher.js');
var Constants 		= require('../constants/course-search-constants.js');

var ActionTypes 	= Constants.ActionTypes;
var PayloadSources 	= FluxConstants.PayloadSources;

var storeData = {
	baseSearchContext: null,
	isLoading: true,
	countryItems: [],
	regionItems: [],
	countyItems: [],
	magazineRatingItems: null,
	playerRatingItems: null,
	greenFeesItems: null,
	navigatedCountry: null,
	navigatedRegion: null,
	navigatedCounty: null,
	navigatedMagazineRating: null,
	navigatedPlayerRating: null,
	navigatedGreenFeesBand: null,
	navigatedTwoForeOneValue: false,
	navigatedGolfWorldTopHundredValue: false,
	latitude: null,
	longitude: null,
	distance: null,
	searchContext: null,
	searchResultsUrl: null,
	searchTerm: null,
	selectedSortOption: 0,
	sortOptions: [
	{"Most Recent": "publish-date-desc"},
	{"Alphabetical (A-Z)": "club-name-asc"},
	{"Alphabetical (Z-A)": "club-name-desc"},
	{"TG rating (high-low)": "todays-golfer-rating-desc"},
	{"TG rating (low-high)": "todays-golfer-rating-asc"},
	{"Player rating (high-low)": "user-rating-desc"},
	{"Player rating (low-high)": "user-rating-asc"},
	{"Green fees (high-low)": "green-fees-rating-desc"},
	{"Green fees (low-high)": "green-fees-rating-asc"},
	{"Distance (nearest first)": "distance-nearest-first"},
	],
	distanceOptions: [
	{"Within 10 miles": "10"},
	{"Within 20 miles": "20"},
	{"Within 30 miles": "30"},
	{"Within 40 miles": "40"},
	{"Within 60 miles": "60"},
	{"Within 100 miles": "100"},
	{"Within 200 miles": "200"}
	],
	totalResults: 0,
	twoForeOneValue: false,
	locationValid: false
};

var store = assign(new FluxChangeStore(), {
	getState: function () {
		return storeData;
	}
});

function handleServerAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.COURSE_SEARCH_LOAD_DATA_SUCCESS:
				handled = true;
				storeData = assign({}, action.data, {
					isLoading: false
				});

				break;
			case ActionTypes.COURSE_SEARCH_LOAD_DATA_ERROR:
				handled = true;
				storeData.isLoading = false;
				// TODO: render error message

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'Course Search',
				message: 'Handle server action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

function handleViewAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.COURSE_SEARCH_UPDATE_FILTERS:
				handled = true;
				storeData.isLoading = true;

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'Course Search',
				message: 'Handle view action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

store.dispatchToken = FluxDispatcher.register(function (payload) {
	if (payload && payload.source) {
		if (payload.source === PayloadSources.SERVER_ACTION) {
			handleServerAction(payload.action);
		} else if (payload.source === PayloadSources.VIEW_ACTION) {
			handleViewAction(payload.action);
		}
	}
});

module.exports = store;